import * as types from '../../actions/actionTypes';
import initialState from '../initialState';

export const deLabelReducer = (state = initialState.deLabel, action) => {
  switch (action.type) {
    case types.RESET_DE_LABEL:
      return {
        ...state,
        ...initialState.deLabel,
      };
    case types.RESET_TARGET_LABEL:
      return {
        ...state,
        loading: false,
        selectedTargets: null,
        targetExpression: [],
      };
    case types.SET_TARGET_LABEL:
      return {
        ...state,
        loading: true,
        selectedTargets: action.payload,
      };
    case types.SET_TARGET_LABEL_EXPRESSION:
      return {
        ...state,
        loading: false,
        targetExpression: action.payload,
      };
    case types.DE_EXPORT_TARGET: {
      const link = document.createElement('a');
      document.body.appendChild(link);
      link.href = action.payload.url;
      link.click();
      return state;
    }
    default:
      return state;
  }
};
